// DTO for bulk assign contractor request
export interface BulkAssignContractorRequestDto {
  shiftNeedIds: string[];
  contractorId: string;
  requestedBy: string;
  message?: string;
}

// DTO for individual result of bulk assignment
export interface BulkAssignContractorResultDto {
  shiftNeedId: string;
  success: boolean;
  shiftRequestId?: string;
  errorMessage?: string;
}

// DTO for bulk assign contractor response
export interface BulkAssignContractorResponseDto {
  contractorId: string;
  totalRequested: number;
  successCount: number;
  failureCount: number;
  results: BulkAssignContractorResultDto[];
}
